import logger from './logging';
import StackTrace from 'stacktrace-js';

window.logger = logger;
window.addEventListener('error', (errorEvent) => {
  StackTrace.fromError(errorEvent.error).then((stackFrames) => {
    const stringifiedStack = stackFrames.map((stackFrame) => {
      return stackFrame.toString();
    }).join('\n');
    const message = `${errorEvent.message}\nStack trace:\n${stringifiedStack}`;
    logger.error(message);
  });
});